AoPS.Utils.initKeyChain(AoPS, "Consultation");

AoPS.Consultation = (function (Consultation) {
	Consultation.Router = Backbone.Router.extend({
		initialize: function (options) {
			this.models = {};
			this.models.master = options.master;
			this.myPage = new AoPS.Page.constructPage("consultation-request");

			this.route(/(.*)/, this.showStartPage);
		},

		/**
		 * This shows the top level page, attaching it to #main-page.
		 * This works by attaching the MainView, which in turn attaches
		 * sub-views based on various conditions.
		 */
		showStartPage: function () {
			this.myPage.clearPage();
			this.myPage.showElement({
				id: "main-page",
				constructor: _.bind(function () {
					// MainView, defined in request_views.js, will branch
					// off based on various things to decide which form or
					// error message to display.
					return new AoPS.Consultation.Views.MainView({
						model: this.models.master,
					});
				}, this),
			});
		},
	});

	$(window).on("load", function () {
		// Magical refresh
		AoPS.refreshOnBackButtonLoadWithOldData("consultation-request");

		/**
		 * I usually start by building a master model that
		 *  is the air-traffic controller for everything.
		 */
		var master = new AoPS.Consultation.Models.Master(),
			my_router;

		/**
		 * Then we build the router.
		 */
		my_router = new Consultation.Router({
			master: master,
		});

		/**
		 * In the router, we construct the myPage object that
		 *  controls what we put on the page.  It has
		 *  a master view whose .el element is what we manage
		 *  to control what goes into the DOM.  Here, we add
		 *  that master element to the main-content window.
		 */
		$("#main-column").prepend(my_router.myPage.el);
		/**
		 * And then we press go.
		 */

		AoPS.router_root = "consultation-request";

		Backbone.history.start({pushState: true, root: "consultation-request"});

		$(document).on("click", "a[nav]", function (e) {
			if (!e.metaKey && !e.ctrlKey) {
				Backbone.history.navigate($(this).attr("href"), {trigger: true});
				e.stopPropagation();
				e.preventDefault();
			}
		});
	});
	return Consultation;
})(AoPS.Consultation || {});

$(document).on("click", "#display-login-link", Academy.login.display);

$(document).one("keydown", "#parent-first-1", function () {
	window.dataLayer.push({event: "consultation_start"});
});
